module.exports = __webpack_public_path__ + "static/images/wellness-hero.1a8967855436199960e6203b826c0d3b.png";